module.exports = __webpack_public_path__ + "img/gongxin.dab5203e.jpg";